module.exports = __webpack_public_path__ + "img/25.c5645a24.png";